/*
 * @Author: lanpang
 * @Date:   2021-06-20 15:18:09
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-06-21 20:24:04
 */
import { initAllDeviceInfo, getAccountInfo } from '../jsapiUtil';
import querystring from 'query-string';
import _ from 'lodash';
import C4PV, { getQIMEI36 } from '../C4PV';

const getLocation = () => {
  return new Promise((res) => {
    const getGeoLocation = _.get(window, 'browser.app.getGeoLocationWithAlert');
    try {
      if (getGeoLocation) {
        getGeoLocation(({ latitude, longitude }) => {
          res({ latitude, longitude });
        });
      } else {
        res({});
      }
    } catch (error) {
      res({});
    }
  });
};

export async function reportBaseData(articleData = {}) {
  const { latitude = '', longitude = '' } = await getLocation();
  // eslint-disable-next-line
  const { C11 = '' } = await C4PV() || {}; // 获取wifi名
  const qimei36 = await getQIMEI36();
  const {
    qbid,
    nickname, // 用于判断是否登陆
  } = (await getAccountInfo().catch(() => {})) || {};
  /* eslint-disable */
  const {
    guid,
    appVersion,
    androidId: android_id,
    idfv: ifv_id,
    network: network_type,
    imsi = '',
    wifiMac: MAC_ADDRESS,
    qimei,
    qua,
    imei,
  } = (await initAllDeviceInfo().catch(() => {})) || {};
  let algorithm_id = 0, channel_id = 0;
  try { // 避免json parse解析报错
    const { report_info = '' } = querystring.parseUrl(location.href).query || {}; // 推荐通过url下发
    const reportInfoObj = (report_info && JSON.parse(report_info) || {});
    algorithm_id = reportInfoObj.uint32_algorithm_id || 0;
    channel_id = reportInfoObj.uint32_channel_id || 0;
  } catch (e) { /*ignore*/ }
  return {
    guid,
    appVersion,
    android_id,
    ifv_id,
    network_type,
    imsi,
    wifiMac: MAC_ADDRESS,
    wifi_ssid: C11,
    qimei,
    qimei36,
    qbid,
    login_info: nickname ? 1 : 0,
    longitude,
    latitude,
    kd_id: articleData.kd_id,
    qua,
    imei,
    algorithm_id,
    channel_id: articleData.ch || channel_id,
    kandian_mode_new: 6, // qb看点tab
    scene_type: 2, // 图文详情页
    is_intensify: 0, // 是否是强化的账号区 图文正文都不是 顶bar是
    puin: articleData.fusionId?.split('_')[1],
  };
}

export async function getAllInfo({ rowkey = '', fusionId = '', kd_id = '' }) {
  const { latitude = '', longitude = '' } = {};
  const accountInfo = (await getAccountInfo().catch(() => {})) || {};
  accountInfo.fromuin = accountInfo.uin;
  accountInfo.touin = fusionId.split('_')[1];
  const deviceInfo = (await initAllDeviceInfo().catch(() => {})) || {};
  deviceInfo.ifv_id = deviceInfo.idfv;
  deviceInfo.MAC_ADDRESS = deviceInfo.wifiMac;
  deviceInfo.network_type = deviceInfo.network;
  deviceInfo.android_id = deviceInfo.androidId;
  deviceInfo.version = deviceInfo.appVersion;
  return {
    ...accountInfo,
    ...deviceInfo,
    algorithm_id: 1, // 算法ID 不知道。。。
    kandian_mode_new: 6, // qb看点tab
    scene_type: 2, // 图文详情页
    r4: rowkey,
    rowkey: rowkey,
    is_intensify: 0, // 是否是强化的账号区 图文正文都不是 顶bar是
    kd_id,
    op_cnt: 1,
    feeds_type: 1095,
  };
}
